import { createFileRoute } from "@tanstack/react-router";
import { StubAdminPage } from "@/components/admin/StubAdminPage";
import { Building2 } from "lucide-react";

export const Route = createFileRoute("/admin/company-profile")({
  component: () => (
    <StubAdminPage
      icon={Building2}
      title="Company Profile"
      subtitle="Bacha Way Travel SARL — settings and details"
    />
  ),
});
